export const affordableEnTranslation = {
  affordable: {
    prequalify: {
      title: "Income Pre-Qualification",
      subtitle: "Check if you may qualify for affordable housing at",
      incomeRestricted:
        "This Apartment Complex has income restricted apartments.",
      incomeRestrictedDescription:
        "A unit that requires your household to meet certain restrictions, such as income and student status, that are based on Federal, State, or Local Housing Programs.",
      householdSize: "Your Household Size",
      householdSizeLabel:
        "How many total people will reside in your household in the next 12 months (including minors and any anticipated new members, such as a newborn, spouse, or relative moving in)?",
      continueToIncome: "Continue",
      change: "Change",
      annualIncome: "Annual Gross Income",
      incomeInputLabel:
        "What is your gross estimated household income for the next 12 months?",
      incomeInputHelperGross:
        "Use gross income (before taxes and deductions) — not net or take-home pay. Eligibility limits are set on gross income, so reporting take-home pay can lead to an incorrect result.",
      incomeInputHelperInclude:
        "Include gross income from all adult household members — wages, salary, self-employment, social security, pensions, and other regular income.",
      incomeInputHelperFallback:
        "If you can't estimate the next 12 months, use your prior year's gross household income as a starting point.",
      checkEligibility: "Check My Eligibility",
      loadingUnitRent: "Confirming this unit's rent requirement...",
      eligible: {
        title: "You May Qualify!",
        message:
          "Based on the information provided, your household income is within the income limits for this property.",
        continueButton: "Continue to Application",
      },
      underMinimum: {
        title: "Income Below Minimum Requirement",
        message:
          "Based on the income you entered, your household appears to be below the minimum income requirement for this unit.",
      },
      overIncome: {
        title: "You Appear to Be Over Income",
        message:
          "Based on the income you entered, your household appears to exceed the income limits for an income-restricted unit at this property.",
        contactPrompt:
          "Please contact our office before proceeding so we can review your situation and discuss your options.",
      },
      error: {
        propertyNotFound: "Property not found",
        notAffordable:
          "This property does not participate in affordable housing programs.",
        noIncomeLimits:
          "Income limits are not yet available for this property. Please contact the property office.",
        unitRentUnavailable:
          "We couldn't confirm this unit's rent requirement. Please try again or contact the property office.",
      },
    },
    application: {
      title: "Affordable Housing Application",
      notFound: "Application not found",
      unsavedStepNavigation:
        "This step is not saved yet. Click Next to save it before you leave. Leave without saving?",
      correctionBanner:
        "This application was reopened for corrections. Update the details below, then review and re-submit to send your changes.",
      steps: {
        authorizationToAssist: "Authorization",
        memberProfiles: "Member Profiles",
        rentalDetails: "Rental Details",
        studentStatus: "Student Status",
        specialNeeds: "Special Needs",
        specialStatus: "Special Status",
        householdIncome: "Household Income",
        assets: "Assets",
        financialSummary: "Financial Summary",
        uploadCenter: "Upload Center",
        reviewSign: "Review & Sign",
      },
      continue: "Continue",
      authorizationToAssist: {
        title: "Do you need help with this application?",
        description:
          "Affordable housing applications include several certifications. If someone is helping you complete this application, you must authorize them in writing before you start.",
        yes: "Yes, someone is helping me",
        no: "No, I'm completing this on my own",
        assisterDetails: "Tell us about the person helping you",
        assisterNameLabel: "Name of the person helping you",
        assisterEmailLabel: "Their email address",
        assisterEmailHint:
          "We'll email them a link to sign their part of the authorization.",
        relationshipLabel: "Their relationship to you",
        relationshipOtherLabel: "Please describe",
        relationship: {
          propertyStaff: "Property staff (e.g. leasing agent)",
          caseworker: "My caseworker",
          familyMember: "A family member",
          other: "Other",
        },
        reasonLabel: "Why do you need help?",
        reasonOtherLabel: "Please describe",
        reason: {
          difficultyWriting: "I have difficulty writing",
          difficultyUnderstanding: "I have difficulty understanding the forms",
          lep: "Limited English proficiency",
          other: "Other",
        },
        afterSendNote:
          "When you continue, we'll create the authorization, you'll sign it on the next screen, and your helper will get an email with a link to sign their part.",
        sendAndSign: "Continue to sign",
        signNow: "Sign the authorization",
        signWidgetHint:
          "Sign your part above. Your helper will receive an email with a link to sign their part — you can continue with the application now.",
        iSigned: "I've signed — Continue",
        lockedSigned:
          "You have already signed an Authorization to Assist for this application.",
        lockedDeclined: "You declined assistance for this application.",
        errorGeneric:
          "Something went wrong. Please try again or contact the property office.",
      },
      coApplicant: {
        steps: {
          identity: "Confirm Identity",
        },
        identity: {
          title: "Confirm your identity",
          subtitle:
            "We have your name on file from the household you were invited to. Please confirm and add your date of birth and SSN.",
        },
        header: {
          unit: "Unit",
          moveIn: "Move-in",
        },
      },
      liveInAide: {
        placeholder: "This step is coming soon.",
        steps: {
          identity: "Confirm Identity",
          rentalHistory: "Rental History",
          household: "Household",
          careAttestations: "Care Attestations",
          medicalExpense: "Medical Expense",
          criminalScreening: "Criminal Screening",
          statesLived: "States Lived",
          leasingAck: "Leasing Acknowledgements",
          review: "Review & Submit",
        },
        identity: {
          title: "Confirm your identity",
          subtitle:
            "We have your name and email on file from the household that invited you. Please confirm your details so we can prefill your Live-In Aide forms.",
          contactLabel: "Contact",
          homePhoneLabel: "Home phone",
          mobilePhoneLabel: "Mobile phone",
          residentServedLabel: "Name of Resident Who Will Receive Services",
          residentServedRequired: "Resident name is required",
          exemptLabel: "Exempt status",
          exemptCaption:
            "Only check a box if you are exempt from providing a Social Security Number. Most aides are not — leave both unchecked if you are unsure.",
          exemptNonCitizen: "Non-eligible non-citizen",
          exemptNonCitizenHelp:
            "You are not claiming eligible immigration status.",
          exemptSenior: "Senior with exempt status",
          exemptSeniorHelp:
            "You are an elderly household member covered by HUD's Social Security Number exemption.",
        },
        rentalHistory: {
          title: "Rental history",
          subtitle:
            "Tell us where you live now and where you lived before. Property staff use this to run landlord references.",
          currentTitle: "Current residence",
          previousTitle: "Previous residence",
          previousNote:
            "Optional — but if you start filling it in, we'll need the street address.",
          landlordLabel: "Community / landlord name",
          addressLabel: "Street address",
          cityLabel: "City",
          stateLabel: "State",
          zipLabel: "ZIP code",
          phoneLabel: "Phone",
          startDateLabel: "Start date",
          endDateLabel: "End date",
          landlordRequired: "Community / landlord name is required",
          addressRequired: "Street address is required",
          cityRequired: "City is required",
          stateRequired: "State is required",
          zipRequired: "ZIP code is required",
          zipError: "Enter a valid ZIP code",
        },
        household: {
          title: "Household",
          subtitle:
            "A few quick questions about your housing situation. Please answer each one.",
          required: "Please answer this question",
          yes: "Yes",
          no: "No",
          evictedExplainLabel: "If yes, please explain",
          evictedExplainRequired: "An explanation is required",
          questions: {
            hudAssistance:
              "Are you currently receiving housing assistance through HUD?",
            otherFamilyMoving:
              "Do you have any other family members who plan to move to the unit with you (excluding the resident)?",
            pets: "Do you have any pets?",
            goodStanding:
              "Are you currently a resident in good standing at your current residence?",
            evicted:
              "Have you been evicted, for lease violations, from a landlord during the past 5 years?",
          },
        },
        careAttestations: {
          title: "Live-In Aide requirements",
          subtitle:
            "HUD defines a Live-In Aide by these requirements. Please answer each one.",
          required: "Please answer this question",
          yes: "Yes",
          no: "No",
          questions: {
            essentialCare:
              "Are you able to provide essential care for the resident?",
            obligatedSupport: "Are you obligated to the resident for support?",
            wouldNotLiveExcept:
              "Do you agree that you would not be living in the unit except to provide the necessary supportive services to the resident?",
          },
        },
        medicalExpense: {
          title: "Medical expense",
          subtitle:
            "This helps determine any medical-expense deduction for the resident's household.",
          feeQuestion:
            "Will the resident named above pay you a fee for providing the services of a live-in aide?",
          required: "Please answer this question",
          yes: "Yes",
          no: "No",
          amountLabel: "Fee amount",
          amountRequired: "Amount is required",
          frequencyLabel: "Frequency",
          frequencyRequired: "Frequency is required",
          frequencies: {
            yearly: "Yearly",
            monthly: "Monthly",
            weekly: "Weekly",
          },
        },
        criminalScreening: {
          title: "Criminal screening",
          subtitle:
            "Property staff use these answers to complete the required background screening. Please answer each one.",
          required: "Please answer this question",
          yes: "Yes",
          no: "No",
          explainLabel: "If yes, please explain",
          explainRequired: "An explanation is required",
          questions: {
            legalActions10y:
              "Have you been involved in any legal actions, including arrests, adjudications, criminal or civil actions, during the past 10 years?",
            sexOffenderLifetime:
              "Are you listed on any state's lifetime sex offender registration?",
            sexOffenderOther:
              "Are you listed on any other sex offender registration?",
            marijuana: "Do you use marijuana?",
            alcoholAbuse: "Do you have a history of alcohol abuse?",
          },
        },
        statesLived: {
          title: "States you have lived in",
          subtitle:
            "Please select each state where you have lived, including Washington, D.C.",
          label: "States lived",
          placeholder: "Type to search states…",
        },
        leasingAck: {
          title: "Leasing acknowledgements",
          subtitle:
            "Please confirm you understand and agree to the following. Answer each one.",
          required: "Please answer this question",
          yes: "Yes",
          no: "No",
          questions: {
            readLease:
              "Have you read and do you understand the Lease Agreement, rules and regulations?",
            agreeAbide:
              "Do you agree to abide by all Lease terms and the Landlord's rules and regulations?",
            understandEviction:
              "Do you understand the landlord will take appropriate action up to and including eviction if you fail to comply?",
            noOccupancyRights:
              "Do you understand you occupy this unit only to provide care to the resident and have no rights to continued occupancy should the resident vacate?",
            vacateIfAbsent:
              "Do you agree to vacate if the resident is absent from the unit longer than 120 days (180 for medical)?",
            vacateOnDeath:
              "In the event the resident passes away, do you understand you must vacate as quickly as possible (HUD subsidy stops 14 days after death)?",
          },
        },
        review: {
          title: "Review & submit",
          subtitle:
            "Please review your answers below before submitting. You'll sign your Live-In Aide forms later, after property staff review.",
          submit: "Submit",
          yes: "Yes",
          no: "No",
          notAnswered: "Not answered",
          noSsn: "No SSN on file",
          noneSelected: "None selected",
          signLater:
            "You won't sign anything on this screen. After property staff review your submission, you'll be invited back to sign your prefilled Live-In Aide forms.",
          sections: {
            identity: "Identity",
            rentalHistory: "Rental history",
            household: "Household",
            careAttestations: "Care attestations",
            medicalExpense: "Medical expense",
            criminalScreening: "Criminal screening",
            statesLived: "States lived",
            leasingAck: "Leasing acknowledgements",
          },
          labels: {
            dob: "Date of birth",
            ssn: "SSN or ITIN",
            residentServed: "Resident receiving services",
            currentResidence: "Current residence",
            previousResidence: "Previous residence",
          },
        },
      },
      memberProfiles: {
        willAnyoneLive:
          "Will anyone else be living with you or joining your household in the next 12 months?",
        answerRequired: "Please answer this question",
        memberRequired: "Add at least one household member",
        addFirstMember: "Add a household member",
        emptyState: "No additional members added yet.",
        memberLabel: "Member",
        livingNowOrAnticipated:
          "Living with you now or anticipated within 12 months?",
        livingNow: "Currently living with me",
        anticipated: "Anticipated within 12 months",
        anticipatedHelper:
          "Use this for newborns, planned adoptions, future spouses, or roommates moving in. Identity documents will be collected at move-in.",
        anticipatedReasonLabel: "Reason",
        anticipatedReasons: {
          newborn: "Newborn / pregnancy",
          adoption: "Adoption or foster placement",
          marriage: "Marriage or new cohabitant",
          roommate: "New roommate",
          other: "Other",
        },
        anticipatedReasonRequired: "Reason is required",
        anticipatedArrivalLabel: "Expected arrival",
        anticipatedArrivalHelper: "MM/YYYY",
        anticipatedArrivalRequired: "Expected arrival is required",
        anticipatedArrivalError: "Use MM/YYYY format",
        yes: "Yes",
        no: "No",
        custodySectionLabel: "Custody",
        custodySectionHelper:
          "HUD/PBRA/811 programs require verification of physical custody for every minor in the household.",
        hasMajorityCustodyLabel:
          "Does this minor reside with you at least 50% of the time?",
        hasMajorityCustodyRequired: "Please indicate the custody arrangement",
        isFosterPlacementLabel: "Is this minor a foster placement?",
        isFosterPlacementRequired:
          "Please indicate whether this minor is a foster placement",
        custodyPercentLabel: "What is the shared custody arrangement?",
        custodyPercentPlaceholder: "e.g. 50%, alternating weeks, primary",
        custodyPercentHelper:
          "Describe the arrangement in percentage or schedule form. Property staff will reconcile with the court order if uploaded.",
        custodyPercentRequired: "Custody arrangement is required",
        hasCourtOrderLabel: "Is there a court order in place?",
        hasCourtOrderRequired: "Please indicate whether a court order exists",
        hasCourtOrderHelper:
          "If Yes, you'll be asked to upload the current order in the Upload Center.",
        liveInAide: "Live-In Aide",
        phoneError: "Use (XXX) XXX-XXXX format",
        dobError: "Use MM/DD/YYYY format",
        dobRequired: "Date of birth is required",
        mustBe18: "Must be 18 or older",
        ssnLabel: "SSN or ITIN",
        noSsnThirdPerson: "Does not have an SSN",
        ssnRequired: "SSN or ITIN is required",
        ssnDigits: "SSN or ITIN must be 9 digits",
        idSectionLabel: "Government-Issued ID",
        idSectionHelper:
          "Optional — minors typically don't have a government-issued ID. Leave blank if they don't have one.",
        govIdTypeLabel: "ID Type",
        govIdTypeRequired: "ID type is required",
        govIdLabel: "ID Number",
        govIdRequired: "ID number is required",
        govIdTypes: {
          driversLicense: "Driver's License",
          stateId: "State ID",
          passport: "Passport / Passport Card",
          militaryId: "Military ID",
          itin: "ITIN",
          foreignGovId: "Government ID from home country",
          other: "Other Government ID",
        },
        studentStatusLabel: "Student Status",
        studentStatusRequired: "Please select a student status",
        studentStatusFullTime: "Full-Time",
        studentStatusPartTime: "Part-Time",
        studentStatusNotStudent: "Not a Student",
        firstNameRequired: "First name is required",
        lastNameRequired: "Last name is required",
        relationshipRequired: "Relationship is required",
        emailRequired: "Email is required",
        emailDuplicate:
          "Each applicant needs their own email address — this one is already used by another household member.",
        emailMatchesPrimary:
          "This email is already used by the primary applicant. Each adult applicant needs their own email address.",
        emailHelper:
          "This person will receive an invite to complete their own application",
        memberPhoneHelper:
          "Used as an SMS fallback if the email invite bounces or isn't responded to.",
        householdSizeMismatch:
          "You indicated {{expected}} people in your household during pre-qualification, but only {{actual}} are listed (including yourself). Please add the remaining members or update your household size if it has changed.",
      },
      demographics: {
        title: "Demographics",
        helper:
          "TDHCA / HUD reporting. You may decline to answer; it will not affect your application.",
        optOut:
          "I do not wish to furnish information regarding ethnicity, race, sex, and disability status.",
        optOutThirdPerson:
          "Decline to provide ethnicity, race, sex, and disability status.",
        required: "Please select an option (or check decline to provide above)",
        sexLabel: "Sex",
        sexMale: "Male",
        sexFemale: "Female",
        ethnicityLabel: "Ethnicity",
        ethnicityHispanic: "Hispanic or Latino",
        ethnicityNotHispanic: "Not Hispanic or Latino",
        raceLabel: "Race",
        raceHelper: "Select all that apply (up to 5)",
        raceWhite: "White",
        raceBlack: "Black / African American",
        raceAmericanIndian: "American Indian / Alaska Native",
        raceAsianIndian: "Asian Indian",
        raceChinese: "Chinese",
        raceFilipino: "Filipino",
        raceJapanese: "Japanese",
        raceKorean: "Korean",
        raceVietnamese: "Vietnamese",
        raceOtherAsian: "Other Asian",
        raceNativeHawaiian: "Native Hawaiian",
        raceGuamanian: "Guamanian or Chamorro",
        raceSamoan: "Samoan",
        raceOtherPacific: "Other Pacific Islander",
        raceOther: "Other",
        disabledLabel: "Are you disabled?",
        yes: "Yes",
        no: "No",
        didNotRespond: "Prefer not to say",
      },
      rentalDetails: {
        yes: "Yes",
        no: "No",
        rentalHistoryTitle: "Rental History",
        rentalHistoryNote:
          "We need at least {{months}} months of housing history. If you've been at your current address less than {{months}} months, add previous addresses until the last {{months}} months are covered.",
        currentAddressTitle: "Current Address",
        previousAddressTitle: "Previous Address",
        previousAddressNote:
          "Required because you've been at your current address less than {{months}} months. Add addresses until the last {{months}} months are covered.",
        previousAddressHeading: "Previous Address {{number}}",
        addAnotherAddress: "Add another address",
        removeAddress: "Remove",
        historyCovered:
          "{{covered}} of {{months}} months of rental history entered.",
        rentalHistoryCoverageError:
          "Add previous addresses until you've covered at least {{months}} months of rental history.",
        housingSituation: "Current Housing Situation",
        housingSituationRenting: "Currently renting",
        housingSituationWithFamily: "Living with family or friend",
        housingSituationOwnHome: "Currently own my home",
        street: "Street Address",
        city: "City",
        state: "State",
        zip: "ZIP",
        moveInDate: "Move-in Date",
        moveOutDate: "Move-out Date",
        landlord: "Landlord / Property Manager",
        landlordPhone: "Landlord Phone",
        landlordEmail: "Landlord Email",
        landlordEmailHelper: "Speeds up reference turnaround.",
        landlordEmailError: "Enter a valid email address",
        landlordContactHelper:
          "Provide at least one \u2014 phone or email \u2014 so we can run a rental reference.",
        landlordContactBothHelper:
          "For your current address, provide both the landlord phone and email so we can run a rental reference.",
        landlordContactRequired:
          "Provide a landlord phone or email so we can run a rental reference.",
        landlordPhoneRequired:
          "Landlord phone is required for your current address.",
        landlordEmailRequired:
          "Landlord email is required for your current address.",
        reasonForLeaving: "Reason for Leaving",
        streetRequired: "Street address is required",
        cityRequired: "City is required",
        stateRequired: "State is required",
        zipRequired: "ZIP is required",
        zipError: "Use 5 or 9 digit ZIP format",
        moveInDateRequired: "Move-in date is required",
        moveOutDateRequired: "Move-out date is required",
        monthYearError: "Use MM/YYYY format",
        previousRequired:
          "Please provide your previous address (required when current move-in is recent).",
        householdNeedsTitle: "Household Needs",
        utilitiesQuestion:
          "Are you able to establish and maintain all required utilities for this unit in your name (or the name of another adult household member)?",
        utilitiesRequired: "Please select yes or no",
        utilityIssueLabel: "Which of the following applies?",
        utilityIssueRequired: "Please select an option",
        utilityIssueOutstandingBalance:
          "I have an outstanding balance with a local utility provider",
        utilityIssueCreditDeposit:
          "I may need a co-signer or a high deposit to establish service",
        utilityIssueFraudIdentity:
          "There is a block on my identity that prevents utility account creation",
        utilityIssueFollowupNote:
          "The property team will reach out to discuss next steps (e.g., proof of a payment plan or a guarantor).",
        accessibilityQuestion:
          "Do you or any household member need an adaptive unit or have accessibility concerns we should know about?",
        accessibilityRequired: "Please select yes or no",
        accessibilityDetails: "Please describe",
        accessibilityDetailsRequired:
          "Please describe your accessibility needs",
        accessibilityDetailsHelper:
          "Shared only with the leasing team to support a reasonable-accommodation request.",
        emergencyContactTitle: "Emergency Contact",
        emergencyContactNote:
          "Please provide an emergency contact. We will only reach out for the reasons you select below.",
        emergencyDecline: "I choose not to provide an emergency contact",
        emergencyName: "Full Name",
        emergencyRelationship: "Relationship",
        emergencyPhone: "Phone",
        emergencyNameRequired: "Name is required",
        emergencyRelationshipRequired: "Relationship is required",
        emergencyPhoneRequired: "Phone is required",
        emergencyReasonsLabel:
          "When may we contact this person? (check all that apply)",
        emergencyReasons: {
          emergency: "Emergency",
          unableToContact: "Unable to contact you",
          terminationOfAssistance: "Termination of assistance",
          latePayment: "Late or non-payment of rent",
          eviction: "Eviction",
          leaseTermsChange: "Change in lease terms",
          houseRulesChange: "Change in house rules",
          other: "Other",
        },
        vehiclesTitle: "Vehicles",
        hasVehicles: "Do you have any vehicles to register?",
        vehicleAnswerRequired:
          "Please answer whether you have vehicles to register",
        vehicleListRequired: "Add at least one vehicle",
        addVehicle: "Add vehicle",
        vehicleLabel: "Vehicle",
        vehicleYear: "Year",
        vehicleMake: "Make",
        vehicleModel: "Model",
        vehicleColor: "Color",
        vehiclePlate: "License Plate",
        vehiclePlatePattern:
          "Enter a valid license plate — letters and numbers only, up to 10 characters, no spaces",
        vehicleState: "State",
        vehicleYearRequired: "Year is required",
        vehicleMakeRequired: "Make is required",
        vehicleModelRequired: "Model is required",
        petsTitle: "Pets & Service Animals",
        hasPets:
          "Do you have any pets, service animals, or emotional support animals?",
        addPet: "Add animal",
        removePet: "Remove animal",
        petLabel: "Animal",
        petCategory: "Animal type",
        petCategoryPet: "Pet",
        petCategoryService: "Service animal",
        petCategoryEsa: "Emotional support animal (ESA)",
        petCategoryNoFeesNote:
          "Service animals and ESAs are not subject to pet rent, deposit, or fees under Fair Housing rules.",
        petName: "Name",
        petType: "Species",
        petTypeDog: "Dog",
        petTypeCat: "Cat",
        petTypeOther: "Other",
        petBreed: "Breed",
        petWeight: "Weight (lbs)",
        petColor: "Color",
        petNameRequired: "Animal name is required",
        petTypeRequired: "Species is required",
      },
      studentDetails: {
        title: "Student Status Certification",
        subtitle: "Select the option that applies to your household.",
        studentDefinition:
          "A student is defined as someone who attends school full time for any part of five or more months in a calendar year (months need not be consecutive).",
        selectOption: "Please select an option",
        selected: "Selected",
        change: "Change",
        optionA:
          "At least one household member is not a student, has not been a student, and will not be during the current and/or upcoming calendar year.",
        optionAHelp: "",
        optionB:
          "All household members are students, but at least one is a part-time student.",
        optionBHelp:
          "Documentation of part-time student status for at least one household member is required.",
        optionC:
          "All household members are full-time students for five or more months during the current and/or upcoming calendar year (months need not be consecutive).",
        optionCHelp: "",
        exemptionsTitle: "LIHTC Student Exemption Questions",
        exemptionsSubtitle:
          "Since all household members are full-time students, please answer each question below.",
        yes: "Yes",
        no: "No",
        answerRequired: "Please answer this question",
        planningQuestion:
          "Will any household member begin or continue as a full- or part-time student during the next 12 months?",
        planningHelp:
          "Include anyone planning to enroll in school, college, or a training program in the coming year.",
        fosterQuestion:
          "Will any foster children or foster adults live in the household?",
        fosterHelp:
          "Answer Yes if a foster child or foster adult is placed with your household.",
        q1: "Is at least one student receiving assistance under title IV of the Social Security Act (for example, payments under AFDC)?",
        q2: "Was at least one student previously under the care of an agency responsible for administering foster care? (provide documentation of participation)",
        q3: "Does at least one student participate in a program receiving assistance under the Job Training Partnership Act (JTPA), Workforce Investment Act or under other similar federal, state or local laws? (attach documentation of participation)",
        q4: "Is at least one student a single parent with child(ren) and this parent is not a dependent of another individual and the child(ren) is/are not dependent(s) of someone other than a parent?",
        q5: "Are the students married and entitled to file a joint tax return?",
        eligibleTitle: "Eligible.",
        eligibleMessage:
          "At least one exemption applies — the household qualifies under LIHTC student rules.",
        ineligibleTitle: "Likely not eligible.",
        ineligibleMessage:
          "Based on your answers, the household likely does not qualify under the student restrictions. If you have any questions or were unsure on any of the answers, please contact the office:",
        callUs: "Call us",
        emailUs: "Email us",
        primaryAnswerNote:
          "The student status below was certified by the primary applicant. If you believe it is incorrect, contact the property office before proceeding.",
        acknowledgeLabel:
          "I certify that the above is true and complete to the best of my knowledge.",
        acknowledgeRequired: "You must acknowledge before continuing",
        memberStudentStatus: {
          sectionTitle: "Student Status — Each Adult",
          sectionSubtitle:
            "For each adult in your household, indicate whether they are a full-time student, part-time student, or not a student.",
          fullTime: "Full-Time Student",
          partTime: "Part-Time Student",
          notStudent: "Not a Student",
          required: "Please select a student status",
        },
      },
      specialNeeds: {
        title: "Special Needs Disclosure",
        subtitle:
          "Some properties have units reserved for households that include a person with a special need. This is voluntary — you are not asked to disclose any details about the type or nature of the special need.",
        categoriesIntro:
          "TDHCA defines a 'Person with Special Needs' as someone in any of these categories:",
        categories: {
          alcoholDrugAddiction:
            "Households where one individual has alcohol and/or drug addictions",
          coloniaResidents: "Colonia residents",
          personsWithDisabilities: "Persons with disabilities",
          vawa: "Persons protected by the Violence Against Women Act (domestic violence, dating violence, sexual assault, stalking)",
          hivAids: "Persons with HIV/AIDS",
          homeless: "Homeless persons",
          veterans: "Veterans",
          woundedWarriors:
            "Wounded warriors (as defined by the Caring for Wounded Warriors Act of 2008)",
          farmworkers: "Farmworkers",
        },
        disclosureNote:
          "You only need to indicate whether someone in your household meets one of the categories above — not which one.",
        txVeteranNoticeTitle:
          "Important Information for Former Military Service Members",
        txVeteranNotice:
          "Women and men who served in any branch of the United States Armed Forces, including Air Force, Army, Navy, Marines, Coast Guard, Reserves or National Guard, may be eligible for additional benefits and services. For more information please visit the Texas Veterans Portal at",
        question: "Does your household include a person with a special need?",
        optionYes: "Yes — at least one household member meets a category above",
        optionNo: "No — no one in the household meets these categories",
        optionDecline: "I do not wish to furnish this information",
        answerRequired: "Please select an option",
        veteranQuestion: "Are you a veteran of the U.S. Armed Forces?",
        veteranYes: "Yes",
        veteranNo: "No",
        veteranRequired: "Please answer this question",
        selected: "Selected",
        primaryAnswerNote:
          "The primary applicant has answered this disclosure on behalf of the household. If you believe it is incorrect, contact the property office before proceeding.",
        acknowledgeLabel: "I acknowledge the primary applicant's answer above.",
        acknowledgeRequired: "You must acknowledge before continuing",
      },
      specialStatus: {
        title: "Special Status Check",
        question:
          "Is the head of household or spouse 62 years of age or older, or disabled?",
        yes: "Yes",
        no: "No",
        answerRequired: "Please answer this question",
        anticipatedAddition: {
          title: "Anticipated Household Addition",
          question:
            "Is anyone in the household expecting a child, in the process of adopting, or obtaining custody of a child?",
          helper:
            "Optional. Answering Yes lets us count the additional household member toward the income limit and unit size.",
          answerRequired: "Please answer this question",
          selectAtLeastOne: "Please select at least one option",
          expectingLabel: "Expecting a child (or children)",
          adoptingLabel: "In the process of adopting a child (or children)",
          custodyLabel:
            "In the process of obtaining custody of a child (or children)",
          dueDateLabel: "Expected due date",
          dueDateInvalid: "Enter a valid date as MM/DD/YYYY",
          dueDateRequired: "Please enter the expected due date",
          explanationLabel: "Comments / explanation (optional)",
          explanationPlaceholder:
            "Add any detail that helps verify the anticipated addition (for example, pending adoption or custody status).",
        },
      },
      householdIncome: {
        yes: "Yes",
        no: "No",
        describeSource: "Describe this income source",
        describePlaceholder: "Briefly describe the source of this income",
        describeRequired: "Please describe this income source",
        requiredYesNo: "Please select Yes or No",
        zeroIncomeMemberMismatch:
          "Looks like you do have some income — please go back and select the income sources you receive before continuing.",
        childSupportChildIdsLabel: "Which minors do you have custody of?",
        childSupportChildIdsHelper:
          "Select the minors in your household for whom you have 50% or more custody.",
        childSupportChildIdsRequired: "Please select at least one minor",
        childSupportStatusLabel:
          "Which describes your child support situation?",
        childSupportStatusRequired: "Please pick one",
        childSupportStatusOptions: {
          a: "Court-ordered and currently receiving support",
          b: "Court-ordered, but NOT receiving and not anticipating any support in the next 12 months",
          c: "Not court-ordered and no documentation; however, I do receive money on a cash basis",
          d: "Never received and not court-ordered; however, I anticipate receiving support in the next 12 months",
          e: "Never received, not court-ordered, and not anticipating any support in the next 12 months",
        },
        childSupportAmountLabel: "Amount",
        childSupportAmountLabelMonthly: "Amount (per month)",
        childSupportAmountRequired: "Please enter an amount",
        childSupportAmountInvalid: "Enter a valid number (e.g. 250 or 250.00)",
        benefitAmountLabel: "Monthly amount",
        benefitAmountPerMonth: "/ month",
        benefitAmountHelper:
          "Enter the gross monthly amount before deductions.",
        benefitAmountRequired: "Please enter the monthly amount",
        benefitAmountInvalid: "Enter a valid number (e.g. 1250 or 1250.00)",
        childSupportFrequencyLabel: "How often?",
        childSupportFrequencyRequired: "Please pick a frequency",
        childSupportFrequencyOptions: {
          week: "Per week",
          month: "Per month",
          annually: "Annually",
        },
        employmentIncomeAmountLabel: "Gross wage amount",
        employmentIncomeAmountHelper:
          "Enter your gross wage, salary, overtime, bonus, and commission income for the selected period.",
        employmentIncomeAmountRequired: "Please enter your gross wage amount",
        employmentIncomeAmountInvalid:
          "Enter a valid number (e.g. 2500 or 2500.00)",
        employmentIncomeFrequencyLabel: "How often are you paid?",
        employmentIncomeFrequencyRequired: "Please pick a pay frequency",
        employmentIncomeFrequencyOptions: {
          weekly: "Weekly",
          biWeekly: "Every two weeks",
          semiMonthly: "Twice per month",
          monthly: "Monthly",
          annually: "Annually",
        },
        cashWorkAmountLabel: "Cash work amount",
        cashWorkAmountHelper:
          "Enter the gross amount you earn from cash work each period.",
        cashWorkAmountRequired: "Please enter an amount",
        cashWorkAmountInvalid: "Enter a valid number (e.g. 250 or 250.00)",
        cashWorkFrequencyLabel: "How often?",
        cashWorkFrequencyRequired: "Please pick a frequency",
        additionalJobs: {
          title: "Additional jobs or side income",
          helper:
            "Working more than one job, or doing cash / side work somewhere else? Add each one here so all income is listed.",
          add: "Add another job or side income",
          remove: "Remove",
          jobLabel: "Job {{n}}",
          kindLabel: "What kind of income is this?",
          kindRequired: "Please pick the type of income",
          kindOptions: {
            wages: "Wages / salary (another job)",
            cashWork: "Cash work or side income",
            selfEmployment: "Self-employment / freelance",
          },
          amountLabel: "Gross amount",
          amountRequired: "Please enter an amount",
          amountInvalid: "Enter a valid number (e.g. 250 or 250.00)",
          frequencyRequired: "Please pick a frequency",
        },
        recurringGift: {
          title: "Who provides this support?",
          helper:
            "We'll email this person directly so they can verify the amount and frequency. To meet HUD chain-of-custody rules, you won't see or fill out their portion of the form — they'll sign in their own session.",
          sourceNameLabel: "Their full name",
          sourceNameRequired: "Please enter their name",
          sourceEmailLabel: "Their email address",
          sourceEmailRequired: "Please enter their email",
          sourceEmailInvalid: "Enter a valid email address",
          sourcePhoneLabel: "Their phone (optional)",
          sourcePhoneHelper:
            "Optional — staff may use this as a fallback if they don't respond by email.",
        },
        cashTip: {
          occupationLabel: "Job title or occupation",
          occupationPlaceholder: "e.g. Server, Bartender, Cashier",
          occupationRequired: "Please enter your job title or occupation",
          industryLabel: "Industry",
          industryRequired: "Please enter your industry",
          employerNameLabel: "Employer name",
          employerNameRequired: "Please enter your employer's name",
          employerAddressLabel: "Employer street address",
          employerAddressRequired: "Please enter your employer's address",
          employerCityStateZipLabel: "Employer city, state, ZIP",
          employerCityStateZipPlaceholder: "e.g. Austin, TX 78701",
          employerCityStateZipRequired:
            "Please enter your employer's city, state, and ZIP",
          employerWorkPhoneLabel: "Work phone number",
          employerWorkPhoneRequired: "Please enter your work phone number",
          startDateLabel: "Start date",
          startDateRequired: "Please enter your start date",
          endDateLabel: "End date",
          currentlyEmployedLabel: "I currently work here",
          supervisorNameLabel: "Supervisor name",
          supervisorNameRequired: "Please enter your supervisor's name",
          supervisorPhoneLabel: "Supervisor phone",
          supervisorPhoneOptional: "Optional",
          supervisorPhoneRequired: "Please enter your supervisor's phone",
          statusLabel: "Which of these best describes your tip situation?",
          statusUnreported:
            "I receive cash tips that I do NOT report to my employer",
          statusReported: "All my tips are reported on my pay stubs",
          statusNone: "I'm not in a tipped position",
          statusRequired: "Please pick one option",
          frequencyLabel: "How often do you receive these tips?",
          frequencyDaily: "Daily",
          frequencyWeekly: "Weekly",
          frequencyBiWeekly: "Bi-weekly",
          frequencySemiMonthly: "Semi-monthly",
          frequencyMonthly: "Monthly",
          frequencyQuarterly: "Quarterly",
          frequencyAnnually: "Annually",
          frequencyRequired: "Please pick how often",
          amountLabel: "Average amount per period",
          amountHelper:
            "Average cash tips per period, in addition to anything reported on pay stubs.",
          amountInvalid:
            "Enter a valid amount (numbers only, up to 2 decimals)",
          amountRequired: "Please enter an amount",
          notTippedExplanationLabel: "Briefly explain",
          notTippedExplanationPlaceholder:
            "e.g. Office assistant — no customer tipping in my role",
          notTippedExplanationRequired:
            "Please briefly explain why your role isn't tipped",
        },
        hcv: {
          intro:
            "A few quick questions about your Housing Choice Voucher. This helps us confirm your approved unit size and flag any portability deadlines so the voucher doesn't lapse mid-process.",
          hasVoucherLabel: "Do you hold a Housing Choice Voucher?",
          bedroomSizeLabel: "Approved bedroom size on your voucher",
          bedroomSizeRequired: "Please select an approved bedroom size",
          bedroomSize: {
            studio: "Studio / Efficiency",
            one: "1 bedroom",
            two: "2 bedrooms",
            three: "3 bedrooms",
            four: "4 bedrooms",
            fivePlus: "5 or more bedrooms",
          },
          isPortingLabel: "Are you porting your voucher from another PHA?",
          isPortingHelper:
            "Porting means you received your voucher from a different Public Housing Authority and are bringing it to this jurisdiction.",
          issuingPhaLabel: "Issuing Public Housing Authority (optional)",
          issuingPhaPlaceholder: "e.g. Houston Housing Authority",
          issuingPhaHelper:
            "Name of the PHA that issued your voucher. Helps staff reach the right contact for the portability transfer.",
          expiresLabel: "When does your portability authorization expire?",
          expiresHelper:
            "From the portability paperwork your issuing PHA sent. A lapsed voucher mid-process means we can't move you in.",
          expiresRequired: "Please enter the portability expiration date",
          expiresInvalid: "Use MM/DD/YYYY format",
        },
        groups: {
          // Initial pass — current-state framing. Section A signal source for
          // the zero-income cert; also gates whether the zero-income screen
          // (and the next-12-months second pass) renders at all.
          employment: {
            title: "Employment & Self-Employment",
            subtitle: "Do you currently earn any of these?",
          },
          cashTip: {
            title: "Cash Tip Income",
            subtitle:
              "LIHTC requires every employed adult to declare how they receive tips — even if you don't get tips at all.",
          },
          cashWork: {
            title: "Cash Work Income",
            subtitle:
              "Tell us who pays you and how much you earn from cash work. LIHTC counts cash earnings as income, so we need these details.",
          },
          benefits: {
            title: "Government & Military Benefits",
            subtitle: "Do you currently receive any of these benefits?",
          },
          socialSecurity: {
            title: "Social Security & Disability",
            subtitle: "Do you currently receive any of these?",
          },
          support: {
            title: "Support & Assistance",
            subtitle: "Do you currently receive any of the following?",
          },
          other: {
            title: "Other Income",
            subtitle: "Do you currently have any of these income sources?",
          },
          zeroIncome: {
            title: "Zero Income",
            subtitle:
              "You didn't select any current income source. Please confirm that you have zero current income.",
          },
          anyOther: {
            title: "Any other income?",
            subtitle: "Any other current income source we haven't covered?",
          },
          hcv: {
            title: "Housing Choice Voucher",
            subtitle:
              "Confirming voucher details now prevents a lapsed authorization mid-process.",
          },
          spousalStatus: {
            title: "Spousal Status",
            subtitle:
              "These questions document income eligibility for affordable housing — your application will not be denied based on your marital status.",
          },
          childSupportCert: {
            title: "Child Support",
            subtitle:
              "LIHTC requires this certification for every adult when minors are listed in your household.",
          },
          // Second pass — only rendered when the applicant confirmed zero
          // current income. Same item list, forward-looking framing. Feeds
          // the zero-income cert's Section B (pending_new_income).
          next12Intro:
            "Even though you have no current income, please tell us about any income you anticipate over the next 12 months.",
          employmentNext12: {
            title: "Employment — next 12 months",
            subtitle: "Will you earn any of these over the next 12 months?",
          },
          benefitsNext12: {
            title: "Government & Military Benefits — next 12 months",
            subtitle:
              "Will you receive any of these benefits over the next 12 months?",
          },
          socialSecurityNext12: {
            title: "Social Security & Disability — next 12 months",
            subtitle: "Will you receive any of these over the next 12 months?",
          },
          supportNext12: {
            title: "Support & Assistance — next 12 months",
            subtitle:
              "Will you receive any of the following over the next 12 months?",
          },
          otherNext12: {
            title: "Other Income — next 12 months",
            subtitle:
              "Will you have any of these income sources over the next 12 months?",
          },
          anyOtherNext12: {
            title: "Any other income — next 12 months",
            subtitle:
              "Any other income source over the next 12 months that we haven't covered?",
          },
          // Section C of the zero-income cert — only rendered when the
          // applicant has zero current AND zero anticipated income. The
          // cert asks who pays each expense category (person, entity, or
          // "N/A" if it doesn't apply).
          expensesPaySources: {
            title: "How will you pay your expenses?",
            subtitle:
              'Since you have no current and no anticipated income, please tell us who will be paying for each expense — write the name of the person or entity, or "N/A" if it doesn\'t apply.',
          },
        },
        items: {
          employmentIncome: {
            title: "Wages, salary, tips, overtime",
            description:
              "Any paycheck-based earnings, including bonuses and commissions",
          },
          selfEmployment: {
            title: "Self-employment",
            description: "Business income, freelance, independent contractor",
          },
          cashWork: {
            title: "Work for cash (babysitting, lawn)",
            description:
              "House cleaning, handyman work, or any informal cash jobs",
          },
          unemployment: {
            title: "Unemployment benefits",
            description: "State or federal unemployment compensation",
          },
          vaGiBill: {
            title: "VA / GI Bill benefits",
            description: "Veterans Affairs benefits or GI Bill",
          },
          militaryIncome: {
            title: "Military income",
            description: "Active duty pay, reserve pay, allowances",
          },
          publicAssistance: {
            title: "Public assistance",
            description: "TANF, GAU, cash assistance programs",
          },
          ssRetirement: {
            title: "Social Security retirement",
            description: "Social Security retirement benefits",
          },
          ssiSsdi: {
            title: "SSI or SSDI",
            description:
              "Supplemental Security Income or Social Security Disability",
          },
          disabilityDeathBenefits: {
            title: "Disability/death benefits",
            description: "Non-Social Security disability or death benefits",
          },
          workersComp: {
            title: "Worker's Compensation",
            description: "L&I / Worker's Compensation benefits",
          },
          cashAssistanceFromOthers: {
            title: "Cash assistance from others",
            description:
              "Regular cash gifts from family, friends, or organizations",
          },
          billPaymentHelp: {
            title: "Bill payment help from others",
            description:
              "Someone regularly pays your bills (rent, utilities, etc.)",
          },
          trustsAnnuitiesPensions: {
            title: "Trusts, annuities, pensions",
            description:
              "Income from trusts, annuities, inheritance, or pensions",
          },
          interestDividends: {
            title: "Interest/dividends from assets",
            description:
              "Interest from savings or CDs; dividends from stocks, bonds, or investment accounts",
          },
          realEstatePropertyIncome: {
            title: "Income from rental property",
            description: "Rent collected from a property or unit you own",
          },
          onlineIncome: {
            title: "Online income",
            description: "Gig economy, reselling, freelance platforms",
          },
          directSales: {
            title: "Direct Sales (Mary Kay, etc.)",
            description:
              "Avon, Tupperware, doTERRA, or similar direct-sales / MLM products",
          },
          educationAssistance: {
            title: "Education financial assistance",
            description: "Scholarships, grants, stipends (beyond tuition)",
          },
          unearnedIncomeMinors: {
            title: "Unearned income for minors",
            description: "Trust funds, investments, or other income for minors",
          },
          publicHousingSection8: {
            title: "Public housing / Section 8",
            description: "Housing Choice Voucher or public housing",
          },
          zeroIncomeMember: {
            title: "No income from any source",
            description:
              "No wages, no benefits, no support — nothing right now",
          },
          otherIncomeNotListed: {
            title: "Any other income source",
            description:
              "Any income source not covered in the previous screens",
          },
          pendingJobOffer: {
            title:
              "Have you accepted an offer of employment that hasn't started yet?",
            description:
              "Only check Yes if you have a signed offer letter from a specific employer and are waiting to start.",
          },
        },
        spousalStatus: {
          maritalStatusLabel: "Marital status",
          maritalStatusRequired: "Please select your marital status",
          options: {
            Single: "Single",
            Married: "Married",
            Separated: "Separated",
            Estranged: "Estranged",
            Divorced: "Divorced",
            Widowed: "Widowed",
          },
          certNotice:
            "Because you selected Separated or Estranged, you'll need to sign a Marital Separation/Estrangement Certification later.",
          spouseNameLabel: "Spouse's full name",
          spouseNameRequired: "Please enter your spouse's name",
          separationDateLabel: "Date of separation (optional)",
          estrangedConfirmText:
            "I am ESTRANGED from my spouse (not yet legally separated or divorced). They will not be contributing financially and WILL NOT be living in the apartment at any time during my tenancy.",
          estrangedConfirmRequired: "Please confirm by checking the box above.",
          estrangedInitialsLabel: "Initial here",
          estrangedInitialsRequired: "Please enter your initials",
          receivingContributionLabel:
            "Are you receiving any spousal contributions to your household?",
          receivingContributionRequired: "Please answer yes or no",
          contributionAmountLabel:
            "Spousal contribution amount per month (anticipated for the next 12 months)",
          contributionAmountHelper:
            "Verification is required. You must notify the office immediately of any change in this amount.",
          amountRequired: "Please enter the amount you receive",
          anticipatedSpousalContributionLabel:
            "Do you expect to receive spousal contributions in the next 12 months?",
          anticipatedSpousalContributionRequired: "Please answer yes or no",
          awardedIncomeLabel:
            "Have you been awarded income such as alimony, child support, or survivor benefits?",
          awardedIncomeRequired: "Please answer yes or no",
          anticipatedAwardedIncomeLabel:
            "Do you expect to be awarded alimony, child support, or survivor benefits in the next 12 months?",
          anticipatedAwardedIncomeRequired: "Please answer yes or no",
          possessLegalDocsLabel:
            "Do you have legal documents (divorce decree, separation agreement) to verify your status?",
          possessLegalDocsRequired: "Please answer yes or no",
          noLegalDocsReasonLabel: "Why don't you have legal documents?",
          noLegalDocsReasonRequired: "Please explain",
          legalActionsLabel:
            "What legal actions have you taken to collect payments owed to you?",
          legalActionsPlaceholder:
            "e.g. Filed with Office of the Attorney General; consulted family attorney; none",
        },
        expensesPaySources: {
          placeholder: "Person, entity, or N/A",
          fields: {
            rent: "Rent (including garage rent, if applicable)",
            utilities: "Utilities",
            food: "Food",
            clothing: "Clothing",
            schoolSupplies: "School supplies",
            phone: "Cell phone or phone",
            tvInternet: "TV (cable, dish, satellite) and/or internet",
            medical: "Medical care",
            medications: "Medications & prescriptions",
            personalCare: "Personal care products (shampoo, toothpaste, etc.)",
            vehicle: "Vehicle expenses (car payments, insurance, fuel, etc.)",
            creditCards: "Payments on credit card balances",
            other: "Other expenses not listed above",
            additionalComments: "Additional comments",
          },
        },
      },
      assets: {
        yes: "Yes",
        no: "No",
        continue: "Continue",
        back: "Back",
        groups: {
          financialAccounts: {
            title: "Financial Accounts",
            subtitle: "Does your household hold any of these accounts?",
          },
          investmentsInsurance: {
            title: "Investments & Insurance",
            subtitle: "Does your household own any of these?",
          },
          otherAssets: {
            title: "Other Assets",
            subtitle: "Does your household have any of these?",
          },
          disposedAssets: {
            title: "Disposed Assets — Past 2 Years",
            subtitle:
              "List each asset you or anyone in your household gave away or sold for less than fair market value in the past 2 years. Up to 3 entries.",
          },
        },
        disposed: {
          rowLabel: "Asset {{n}}",
          removeRow: "Remove this asset",
          typeLabel: "Type of asset",
          typePlaceholder: "e.g. 2018 Honda Civic",
          fairMarketValueLabel: "Fair market value",
          actualAmountReceivedLabel: "Actual amount received",
          dateOfDisposalLabel: "Date of disposal",
          dateOfDisposalHelper:
            "Must be within the past 2 years (LIHTC compliance window).",
          dateOutOfRange:
            "Date of disposal must be within the past 2 years (and not in the future).",
          explanationLabel: "Explanation",
          explanationPlaceholder:
            "e.g. Car gifted to my brother who was facing medical hardship",
          addFirstRow: "+ Add disposed asset",
          addAnotherRow: "+ Add another asset ({{remaining}} left)",
          atLeastOneRowRequired: "Please list at least one disposed asset",
          maxRowsExceeded:
            "You can list up to 3 assets here. Use the explanation field for anything additional.",
          rowFieldRequired: "This field is required",
          currencyInvalid:
            "Enter a valid amount (digits only, e.g. 1250 or 1250.50)",
          dateInvalid: "Please pick a valid date",
          explanationRequired:
            "Please briefly explain why these assets were disposed",
        },
        items: {
          checking: {
            title: "Checking account(s)",
            description: "Personal or joint checking accounts",
          },
          savings: {
            title: "Savings account(s)",
            description: "Personal or joint savings accounts",
          },
          internetBased: {
            title: "Internet-based assets",
            description: "Cash App, Venmo, PayPal, Apple Pay balances",
          },
          debitCards: {
            title: "Debit cards (not linked to bank)",
            description: "Prepaid or reloadable debit cards",
          },
          moneyMarket: {
            title: "Money market accounts",
            description: "Money market deposit accounts",
          },
          cashOnHand: {
            title: "Cash on hand",
            description: "Physical cash held by anyone in the household",
          },
          brokerage: {
            title: "Brokerage accounts",
            description: "Investment brokerage accounts",
          },
          capitalInvestments: {
            title: "Capital investments",
            description: "Business or capital investment holdings",
          },
          stocks: {
            title: "Stocks",
            description: "Individual stocks, mutual funds, or ETFs",
          },
          bonds: {
            title: "Bonds",
            description: "Government, corporate, or municipal bonds",
          },
          annuities: {
            title: "Annuities",
            description: "Fixed or variable annuity contracts",
          },
          cds: {
            title: "Certificate of Deposit",
            description: "CDs at banks or credit unions",
          },
          cryptocurrency: {
            title: "Cryptocurrency",
            description: "Bitcoin, Ethereum, or other digital currencies",
          },
          lifeInsurance: {
            title: "Life insurance (non-term)",
            description:
              "Whole life, universal life, or variable life policies",
          },
          trustFunds: {
            title: "Trust funds",
            description: "Trust funds under household member control",
          },
          lumpSumAmounts: {
            title: "Lump sum amounts",
            description: "Lottery winnings, inheritance, insurance settlements",
          },
          safetyDepositBox: {
            title: "Safety deposit box contents",
            description: "Valuables stored in a safety deposit box",
          },
          realEstateProperty: {
            title: "Real estate property",
            description: "Land or property owned by household members",
          },
          landContracts: {
            title: "Mortgages or land contracts you hold",
            description:
              "A note or land contract where a buyer makes payments to you — e.g. you sold a property and carry the loan yourself",
          },
          taxRefund: {
            title: "State tax refund (last 12 months)",
            description:
              "A state tax refund you still have in your accounts or as cash. (Federal refunds are covered in the next question.)",
          },
          crowdsourcing: {
            title: "GoFundMe / Crowdsourcing",
            description:
              "Balance from GoFundMe, Kickstarter, or any online fundraising campaign",
          },
          assetsGivenAway: {
            title: "Assets given away below value",
            description:
              "Assets sold or given away below fair market value (past 2 years)",
          },
          personalPropertyInvestment: {
            title: "Personal property held as investment",
            description:
              "Collectibles, art, vehicles, or other personal property held for value",
          },
          otherAssetsNotListed: {
            title: "Other assets",
            description: "Any other assets not listed above",
          },
        },
        requiredYesNo: "Please select Yes or No",
        personalPropertyExplanationLabel: "Describe the personal property",
        personalPropertyExplanationPlaceholder:
          "e.g. 1968 Mustang restored — held for investment value",
        personalPropertyExplanationRequired:
          "Please describe the personal property",
        otherAssetExplanationLabel: "Describe the other asset(s)",
        otherAssetExplanationPlaceholder:
          "e.g. Inherited gold coins, business equipment held outside a company",
        otherAssetExplanationRequired: "Please describe the other asset(s)",
        value: {
          cashValueLabel: "Current value",
          interestRateLabel: "Interest rate",
          annualIncomeLabel: "Yearly income",
          dividendIncomeLabel: "Annual dividends / distributions",
          rentalIncomeLabel: "Annual net rental income",
          dividendIncomeHelper:
            "Total dividends or distributions these holdings paid in the last year (enter 0 if none).",
          declaredIncomeRequired: "Enter the annual income (enter 0 if none)",
          institutionLabel: "Bank / institution",
          institutionPlaceholder: "e.g. Chase, Fidelity, MetLife",
          institutionRequired:
            "Enter the bank or institution holding this asset",
          accountLabel: "Account / policy #",
          accountPlaceholder: "Last 4 digits are fine",
          accountRequired:
            "Enter the account or policy number (last 4 is fine)",
          accountN: "Account {{n}}",
          removeAccount: "Remove account",
          addAccount: "+ Add another {{asset}}",
          accountSubtotal: "Subtotal: {{cash}}  ·  {{income}}/yr",
          accountSubtotalCashOnly: "Subtotal: {{cash}}",
          cashValueRequired: "Enter the account's current value",
          interestRateRequired: "Enter the interest rate (enter 0 if none)",
          interestRateInvalid: "Enter a valid rate (e.g. 1.5)",
          runningTotalLabel: "Total assets",
          underThreshold:
            "You're under {{threshold}} — you won't need to upload asset statements.",
          overThreshold:
            "You're over {{threshold}} — you'll need to upload statements for your accounts.",
        },
        refund: {
          title: "Federal tax refund",
          question:
            "Did you receive a federal tax refund or refundable tax credit in the last 12 months?",
          amountLabel:
            "How much of that refund is still in your accounts today?",
          amountHelper:
            "Federal refunds don't count as assets for 12 months, so we subtract this amount (HUD rule).",
          receivedRequired: "Please answer Yes or No",
          amountRequired:
            "Enter the amount still held (enter 0 if none remains)",
          amountInvalid: "Enter a valid amount (e.g. 1200.00)",
          grossLabel: "Gross assets",
          lessRefundLabel: "Less held federal refund",
          countableLabel: "Countable assets",
        },
      },
      financialSummary: {
        title: "Financial Summary",
        subtitleSingular:
          "Based on your answers, we identified {{count}} item.",
        subtitlePlural: "Based on your answers, we identified {{count}} items.",
        sectionIncome: "INCOME SOURCES",
        sectionAssets: "ASSETS",
        emptyState: "No income or asset items were selected.",
        benefitsIncomeLabel: "Declared benefits income",
        perMonthSuffix: "/ month",
        verificationNotice:
          "We'll ask for verification documents for these items in the next step.",
      },
      uploadCenter: {
        required: "Required",
        optional: "Optional",
        incompleteRequired:
          "Please upload all required documents before continuing.",
        canSubmitLater:
          "You don't have to upload everything now. To continue without uploading, check the box below to let our team know you'd like help — you can bring your documents to the office or upload them later.",
        needHelpCheckbox: "I'd like help with my documents",
        dragDrop: "Drag & drop or",
        browse: "browse",
        acceptHint: "PDF, JPG, or PNG (max {{maxMb}}MB)",
        oneDocument: "1 document",
        nDocuments: "{{count}} documents",
        upToNDocuments: "Up to {{count}} documents",
        downloadTemplate: "Download template",
        legibility: {
          checking: "Checking image quality…",
          warn: "This file may be hard to read — a clearer scan is recommended.",
          fail: "This file looks too blurry or low-resolution to read. Please replace it with a clearer scan.",
          unsupported:
            "We couldn't read this file. Please upload a PDF, JPG, PNG, or HEIC.",
        },
        universalRules: {
          title: "Before you upload",
          freshness:
            "Every document must be dated within 120 days of your move-in date. If the process takes long, we may ask for fresh paystubs and bank statements.",
          quality:
            "Please avoid blurry phone photos. Use a free scanning app (Adobe Scan, Genius Scan) to create clear, multi-page PDFs.",
        },
        sections: {
          standard: "STANDARD DOCUMENTS",
          income: "INCOME VERIFICATION DOCUMENTS",
          asset: "ASSET VERIFICATION DOCUMENTS",
        },
        groups: {
          standard: {
            title: "Proof of Identity & Household Composition",
            subtitle: "Required for every application.",
          },
          // Income groups (keyed by HouseholdIncomeForm keys)
          employmentIncome: {
            title: "Employment Income Verification",
            subtitle: "Based on your reported income: Employment Income",
          },
          selfEmployment: {
            title: "Self-Employment Verification",
            subtitle: "Based on your reported income: Self-Employment",
          },
          unemployment: {
            title: "Unemployment Benefits Verification",
            subtitle: "Based on your reported income: Unemployment benefits",
          },
          vaGiBill: {
            title: "VA / GI Bill Benefits Verification",
            subtitle: "Based on your reported income: VA / GI Bill benefits",
          },
          militaryIncome: {
            title: "Military Income Verification",
            subtitle: "Based on your reported income: Military income",
          },
          publicAssistance: {
            title: "Public Assistance Verification",
            subtitle: "Based on your reported income: Public assistance",
          },
          ssRetirement: {
            title: "Social Security Retirement Verification",
            subtitle:
              "Based on your reported income: Social Security retirement",
          },
          ssiSsdi: {
            title: "SSI / SSDI Verification",
            subtitle: "Based on your reported income: SSI or SSDI",
          },
          disabilityDeathBenefits: {
            title: "Disability / Death Benefits Verification",
            subtitle:
              "Based on your reported income: Disability/death benefits",
          },
          workersComp: {
            title: "Worker's Compensation Verification",
            subtitle: "Based on your reported income: Worker's Compensation",
          },
          childSupport: {
            title: "Child Support Verification",
            subtitle: "Based on your reported income: Child support payments",
          },
          alimonySpousalSupport: {
            title: "Alimony / Spousal Support Verification",
            subtitle:
              "Based on your reported income: Alimony / spousal support",
          },
          cashAssistanceFromOthers: {
            title: "Cash Assistance Verification",
            subtitle:
              "Based on your reported income: Cash assistance from others",
          },
          billPaymentHelp: {
            title: "Bill Payment Help Verification",
            subtitle:
              "Based on your reported income: Bill payment help from others",
          },
          trustsAnnuitiesPensions: {
            title: "Trusts, Annuities, Pensions Verification",
            subtitle:
              "Based on your reported income: Trusts, annuities, pensions",
          },
          realEstatePropertyIncome: {
            title: "Real Estate / Property Income Verification",
            subtitle:
              "Based on your reported income: Real estate / property income",
          },
          onlineIncome: {
            title: "Online Income Verification",
            subtitle: "Based on your reported income: Online income",
          },
          educationAssistance: {
            title: "Education Assistance Verification",
            subtitle:
              "Based on your reported income: Education financial assistance",
          },
          unearnedIncomeMinors: {
            title: "Unearned Income (Minors) Verification",
            subtitle:
              "Based on your reported income: Unearned income for minors",
          },
          publicHousingSection8: {
            title: "Public Housing / Section 8 Verification",
            subtitle:
              "Based on your reported income: Public housing / Section 8",
          },
          zeroIncomeMember: {
            title: "Zero Income Verification",
            subtitle:
              "Based on your reported income: Household member with no income",
          },
          otherIncomeNotListed: {
            title: "Other Income Verification",
            subtitle: "Based on your reported income: Other income not listed",
          },
          // Live-In Aide group
          liveInAide: {
            title: "Live-In Aide Documentation",
            subtitle:
              "Required because your household includes a Live-In Aide.",
          },
          // Asset groups (keyed by AssetsForm keys)
          checking: {
            title: "Checking Account Verification",
            subtitle: "Based on your reported asset: Checking account(s)",
          },
          savings: {
            title: "Savings Account Verification",
            subtitle: "Based on your reported asset: Savings account(s)",
          },
          internetBased: {
            title: "Internet-Based Assets Verification",
            subtitle: "Based on your reported asset: Internet-based assets",
          },
          debitCards: {
            title: "Debit Cards Verification",
            subtitle:
              "Based on your reported asset: Debit cards (not linked to bank)",
          },
          moneyMarket: {
            title: "Money Market Verification",
            subtitle: "Based on your reported asset: Money market accounts",
          },
          brokerage: {
            title: "Brokerage Accounts Verification",
            subtitle: "Based on your reported asset: Brokerage accounts",
          },
          capitalInvestments: {
            title: "Capital Investments Verification",
            subtitle: "Based on your reported asset: Capital investments",
          },
          stocksBonds: {
            title: "Stocks / Bonds Verification",
            subtitle: "Based on your reported asset: Stocks / Bonds",
          },
          annuities: {
            title: "Annuities Verification",
            subtitle: "Based on your reported asset: Annuities",
          },
          cds: {
            title: "Certificate of Deposit Verification",
            subtitle: "Based on your reported asset: Certificate of Deposit",
          },
          cryptocurrency: {
            title: "Cryptocurrency Verification",
            subtitle: "Based on your reported asset: Cryptocurrency",
          },
          lifeInsurance: {
            title: "Life Insurance Verification",
            subtitle: "Based on your reported asset: Life insurance (non-term)",
          },
          trustFunds: {
            title: "Trust Funds Verification",
            subtitle: "Based on your reported asset: Trust funds",
          },
          lumpSumAmounts: {
            title: "Lump Sum Verification",
            subtitle: "Based on your reported asset: Lump sum amounts",
          },
          safetyDepositBox: {
            title: "Safety Deposit Box Verification",
            subtitle:
              "Based on your reported asset: Safety deposit box contents",
          },
          realEstateProperty: {
            title: "Real Estate Property Verification",
            subtitle: "Based on your reported asset: Real estate property",
          },
          taxRefund: {
            title: "State Tax Refund Verification",
            subtitle:
              "Based on your reported asset: State tax refund (last 12 months)",
          },
          assetsGivenAway: {
            title: "Assets Given Away Verification",
            subtitle:
              "Based on your reported asset: Assets given away below value",
          },
          otherAssetsNotListed: {
            title: "Other Assets Verification",
            subtitle: "Based on your reported asset: Other assets not listed",
          },
        },
        documents: {
          // Standard
          photoId: {
            title: "Government-Issued Photo ID",
            description:
              "Driver's license, passport, or state-issued ID for every adult household member",
          },
          ssCard: {
            title: "Social Security Card",
            description:
              "Original card for every household member, including infants",
          },
          birthCertificate: {
            title: "Birth Certificate",
            description: "For every minor in the household",
          },
          offerLetter: {
            title: "Offer Letter of Employment",
            description:
              "Signed offer letter for a position you have accepted but not yet started.",
          },
          custodyOrder: {
            title: "Custody Court Order",
            description:
              "Current court order showing the custody arrangement for this minor.",
          },
          studentStatusProof: {
            title: "Student Status Proof",
            description:
              "School transcript or registrar's letter verifying full-time or part-time enrollment",
          },
          divorceSeparationPapers: {
            title: "Divorce / Separation Papers",
            description: "To verify entitlement to alimony or child support",
          },
          // Income
          payStubs: {
            title: "Pay Stubs",
            description:
              "Most recent 60 consecutive days of pay stubs. If you have a gap, upload a brief note explaining it.",
          },
          employmentVerificationLetter: {
            title: "Verification of Employment (VOE) or Offer Letter",
            description:
              "Required alongside paystubs. Upload one of: (a) a Verification of Employment (VOE) letter from your employer confirming position, hours, and salary, or (b) a signed offer letter for a new position you've recently accepted. Affordable-housing is a long-term commitment — your employer should be able to issue a VOE on request.",
          },
          federalTaxReturn: {
            title: "Federal Tax Return (Form 1040)",
            description: "Most recent year — all pages and schedules",
          },
          profitAndLoss: {
            title: "Year-to-Date Profit & Loss",
            description: "YTD P&L statement for your business",
          },
          unemploymentBenefitStatement: {
            title: "Unemployment Benefit Letter or Payment History",
            description:
              "Benefit letter or payment history from your state unemployment agency (e.g., EDD, ESD, DWS, Workforce Commission).",
          },
          vaBenefitAwardLetter: {
            title: "VA Benefit Award Letter",
            description: "Most recent VA benefit award letter",
          },
          les: {
            title: "Leave and Earnings Statement (LES)",
            description: "Most recent LES",
          },
          publicAssistanceVerification: {
            title: "Verification of Public Assistance",
            description: "From the issuing agency (TANF, GAU, etc.)",
          },
          ssBenefitLetter: {
            title: "Social Security Benefit Letter",
            description:
              "Current year's letter showing the gross monthly benefit",
          },
          ssaBenefitAwardLetter: {
            title: "SSI / SSDI Award Letter",
            description:
              "For SSI: upload the most CURRENT award or recertification letter (issued within the last 60 days) — SSI can fluctuate throughout the year. For SSDI: the current year's annual letter showing the gross monthly benefit is acceptable.",
          },
          disabilityDeathBenefitLetter: {
            title: "Benefit Award Letter",
            description: "From the issuing source (non-SS)",
          },
          workersCompBenefitLetter: {
            title:
              "Workers' Compensation Benefit Letter, Award, or Payment History",
            description:
              "Most recent document from your state workers' comp insurer (e.g., L&I, DWC, DIR) showing the benefit amount and duration.",
          },
          workersCompAwardDoc: {
            title: "Workers' Compensation Award Documentation",
            description: "Showing amount and duration of the award",
          },
          childSupportOagPrintout: {
            title: "OAG Payment History",
            description:
              "Printout from the Office of the Attorney General showing the last 12 months of payments (even if $0.00)",
          },
          childSupportCashContributionVerification: {
            title: "Verification of Regular Cash Contribution and Gifts",
            description:
              "Signed verification covering the cash child support you receive when no court order / documentation exists",
          },
          childSupportAttorneyLetter: {
            title: "Attorney Letter — Anticipated Child Support",
            description:
              "Letter from your attorney stating the anticipated child support amount you expect to receive in the next 12 months",
          },
          childSupportAffidavit: {
            title: "Child Support Affidavit",
            description:
              "Signed affidavit attesting to child support received (used if no court order / OAG record exists)",
          },
          alimonyDecree: {
            title: "Divorce Decree or Court Order",
            description: "Document establishing the support obligation",
          },
          alimonyPaymentHistory: {
            title: "Alimony Payment History",
            description: "Evidence of payments received over the last 6 months",
          },
          annuityPensionStatement: {
            title: "Annuity / Pension / Retirement Statement",
            description:
              "Most recent statement showing the gross distribution amount",
          },
          trustDocument: {
            title: "Trust Document",
            description: "For trust-related income",
          },
          leaseAgreement: {
            title: "Lease Agreement",
            description: "Current tenant lease agreement",
          },
          scheduleE: {
            title: "Schedule E",
            description: "From most recent federal tax return",
          },
          form1099: {
            title: "1099-NEC or 1099-K",
            description: "Current year 1099 form",
          },
          platformEarningsStatement: {
            title: "Platform Earnings Statement",
            description: "From the gig platform, last 3 months",
          },
          educationAwardLetter: {
            title: "Award Letter",
            description: "From the school or institution",
          },
          minorTrustStatement: {
            title: "Trust Fund / Investment Statement",
            description: "For the minor's account",
          },
          housingAuthorityLetter: {
            title: "Housing Authority Approval Letter",
            description: "From the issuing housing authority",
          },
          otherIncomeDocumentation: {
            title: "Supporting Documentation",
            description: "Describing the source of income not listed above",
          },
          // Assets
          checkingStatements: {
            title: "Checking Account Statements",
            description: "All pages of the most recent 6 consecutive months",
          },
          savingsStatement: {
            title: "Savings Account Statement",
            description: "Most recent month, all pages",
          },
          internetAssetStatement: {
            title: "Balance Screenshot or Statement",
            description:
              "Current month balance for Cash App, Venmo, PayPal, or Apple Pay",
          },
          debitCardValueVerification: {
            title: "Value Verification or Balance Screenshot",
            description:
              "For prepaid debit (Direct Express, Netspend, etc.) — screenshot from ATM or app",
          },
          moneyMarketStatement: {
            title: "Money Market Statement",
            description: "Most recent account statement",
          },
          brokerageStatement: {
            title: "Brokerage Statement",
            description: "Most recent brokerage account statement",
          },
          capitalInvestmentOwnership: {
            title: "Ownership Documentation",
            description: "Operating agreement or shareholder records",
          },
          capitalInvestmentValuation: {
            title: "Valuation Statement",
            description: "Most recent valuation of the investment",
          },
          stocksStatement: {
            title: "Stocks Statement",
            description: "Brokerage account statement showing current holdings",
          },
          bondsStatement: {
            title: "Bonds Statement",
            description:
              "Bond account statement or certificate showing face value",
          },
          annuityContractOrStatement: {
            title: "Annuity Contract or Statement",
            description: "Annuity contract or most recent statement",
          },
          cdStatement: {
            title: "Certificate of Deposit Statement",
            description: "Showing current balance and term",
          },
          cryptoBalanceScreenshot: {
            title: "Current Exchange or Wallet Statement",
            description:
              "Most recent statement (PDF preferred) from the exchange or wallet showing current balance and recent transactions. Screenshots are accepted only if a downloadable statement is not available.",
          },
          lifeInsuranceCashValue: {
            title: "Cash Value Statement",
            description: "From the life insurance policy",
          },
          trustAgreement: {
            title: "Trust Document / Agreement",
            description: "Trust agreement",
          },
          trustAccountStatement: {
            title: "Trust Account Statement",
            description: "Most recent trust account statement",
          },
          lumpSumSourceDocumentation: {
            title: "Source Documentation",
            description:
              "Award letter, settlement statement, or executor letter",
          },
          safetyDepositContentsList: {
            title: "Itemized Contents List",
            description: "Signed by a household member",
          },
          safetyDepositBankVerification: {
            title: "Bank Safety Deposit Box Verification",
            description: "From the bank",
          },
          realEstateTaxAppraisal: {
            title: "Tax Appraisal",
            description: "Most recent tax appraisal",
          },
          mortgageStatement: {
            title: "Mortgage Statement",
            description: "Current mortgage statement",
          },
          landContractDocument: {
            title: "Land Contract Document",
            description:
              "Signed land contract showing terms and purchase price",
          },
          landContractPaymentLedger: {
            title: "Payment Ledger",
            description: "Record of payments received from the buyer",
          },
          crowdsourcingPayoutStatement: {
            title: "Campaign Payout / Deposit Record",
            description:
              "GoFundMe or other platform payout statement, or bank deposit showing total raised",
          },
          personalPropertyAppraisal: {
            title: "Appraisal or Valuation",
            description:
              "Professional appraisal, receipt, or written valuation of the item",
          },
          taxRefundTranscript: {
            title: "Refund Transcript or Deposit Record",
            description:
              "IRS or state refund transcript, or bank deposit statement",
          },
          otherAssetDocumentation: {
            title: "Supporting Documentation",
            description: "Describing the asset not listed above",
          },
          // Live-In Aide documents
          liaQuestionnaire: {
            title: "Live-In Aide Questionnaire",
            description:
              "Completed questionnaire used for criminal background screening of the Live-In Aide. Download the blank template, complete it, and upload the signed copy.",
          },
          liaNeedVerification: {
            title: "Live-In Aide Need Verification",
            description:
              "Documentation from a qualified professional verifying that the Live-In Aide is needed to assist a household member with a disability-related need.",
          },
        },
      },
      reviewSign: {
        title: "Review & Sign",
        subtitle:
          "Please review the information below before submitting your application.",
        householdMembers: "Household Members",
        noHouseholdMembers: "No additional household members added.",
        notAnswered: "Not answered",
        noneSelected: "None selected.",
        documentsCount_one: "{{count}} document",
        documentsCount_other: "{{count}} documents",
        needsDocumentHelpLabel: "Document help",
        needsDocumentHelpValue:
          "You asked for help uploading your documents — our team will reach out.",
        unitLease: {
          title: "Unit & Lease",
          unit: "Unit",
          rent: "Monthly rent",
          moveInDate: "Move-in date",
          term: "Lease term",
          termMonths_one: "{{count}} month",
          termMonths_other: "{{count}} months",
        },
        address: "Address",
        employment: "Employment",
        noVehicles: "No vehicles registered.",
        emergencyContactDeclined: "Declined to provide an emergency contact.",
        yesNo: { yes: "Yes", no: "No" },
        studentStatus: {
          A: "Option A — At least one household member is not a student",
          B: "Option B — All household members are students, at least one part-time",
          C: "Option C — All household members are full-time students",
        },
        certification: {
          title: "Certification",
          label:
            "I certify that all information provided above is true, accurate, and complete to the best of my knowledge.",
        },
        terms: {
          title: "Terms & Conditions",
          body: "By submitting this application, you agree to the following:\n\n1. The information provided is accurate and complete. Any false statement may result in denial of the application or termination of tenancy.\n\n2. You consent to the verification of your income, assets, employment, credit, criminal history, and rental history by the property management and its agents.\n\n3. Application fees are non-refundable.\n\n4. This application does not guarantee approval. Final approval is subject to compliance with program requirements and owner/management review.\n\n5. All documents uploaded must be dated within 120 days of your move-in date.\n\n6. You acknowledge that this is an income-restricted community and your household income must meet program eligibility requirements.",
          accept: "I have read and agree to the Terms and Conditions.",
        },
        signature: {
          title: "Signature",
          instructions:
            "Type your full legal name below to electronically sign this application.",
          label: "Full legal name",
          required: "Signature is required",
          date: "Date",
        },
        submitButton: "Submit Application",
        submitError:
          "We couldn't submit your application. Please try again or contact the property team.",
        success: {
          title: "Application Submitted",
          message:
            "Your application has been submitted. The property team will review it and follow up with you shortly.",
          backToApplications: "Back to Applications",
          correctionTitle: "Correction Submitted",
          correctionMessage:
            "The corrected application has been re-submitted and the lease updated. You can close this tab and return to the admin.",
          close: "Close this tab",
        },
      },
    },
  },
};
